/** Static app routes at `/{segment}` — not hub home (`/[hubSlug]`). */
const STATIC_SINGLE_SEGMENT_ROUTES = new Set([
  "addresses",
  "appointments",
  "cart",
  "contact",
  "contact-franchise",
  "expert-form-submission-thankyou",
  "media",
  "not-found",
  "privacy-policy",
  "products-cart",
  "profile",
  "refer&earn",
  "register-as-a-professional",
  "store",
  "teams",
  "thankyou",
  "wallet",
]);

/** True for `/` and hub home pages like `/noida` (dynamic `[hub]`). */
export function isHomeHubPath(pathname: string | null): boolean {
  if (!pathname || pathname === "/") return true;
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length !== 1) return false;
  return !STATIC_SINGLE_SEGMENT_ROUTES.has(parts[0]);
}
